















import Vue from 'vue';
import type { WithProperties } from 'vue-typed-properties';

import { SldsButton, SldsModal } from '@ui';

export default (
  Vue as WithProperties<{ resolve: (result: boolean) => void }>
).extend({
  name: 'Confirm',
  components: {
    SldsButton,
    SldsModal,
  },
  inheritAttrs: false,
  props: {
    message: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      open: false,
    };
  },
  watch: {
    open(value) {
      if (value === false) {
        this.resolve(false);
      }
    },
  },
  methods: {
    confirm(): Promise<boolean> {
      this.open = true;
      return new Promise((resolve) => {
        this.resolve = resolve;
      });
    },
    accept(): void {
      this.resolve(true);
      this.open = false;
    },
    decline(): void {
      this.resolve(false);
      this.open = false;
    },
  },
});
